import {inject, Injectable, isDevMode} from '@angular/core';

import {CmsApiService} from './cms-api.service';
import {JobStatusSubscriberService} from './jobstatussubcriber/job-status-subscriber.service';
import {UserData} from './definitions/user-data';
import {logout} from '@ekultur/authentication';
import {environment} from '../../environments/environment';
import {BehaviorSubject} from 'rxjs';
import {UserCacheService} from './user-cache.service';
import { PrimusBackendInstanceService } from './primus-backend-instance.service';

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  // Injections
  private readonly cms: CmsApiService = inject(CmsApiService);
  private readonly jobStatusSubscriberService: JobStatusSubscriberService = inject(JobStatusSubscriberService);
  private readonly userCacheService: UserCacheService = inject(UserCacheService);

  debug = undefined;
  progress = 0;

  public currentUser: BehaviorSubject<UserData | null> = new BehaviorSubject(null);

  logoutUser() {
    this.jobStatusSubscriberService.stopPolling();

    this.cms.logout().then(() => {
      this.currentUser.next(null);
      PrimusBackendInstanceService.cleanInstanceDetails();
      logout({
        signal: null,
        apiGateway: environment.ekulturAPIGatewayURL
      });
    });
  }

  async getUserData() {
    // eslint-disable-next-line no-console
    if (isDevMode()) { console.debug('[LOGIN-SERVICE] -- getUserData()'); }
    const userData = await this.userCacheService.getUserData(true);
    if (userData) {
      this.currentUser.next(userData);
    }
  }
}
